import React  from 'react';
import styled from 'styled-components';
import CarouselMain from './CarouselMain';
import AgencyCartSmall from './SmallComps/AgencyCartSmall';
import { Link } from 'react-router-dom';
import { Dictionery } from '../../Data/Dictionery';
import AgencyCart from './SmallComps/AgencyCart';
import AgencyCartSmall2 from './SmallComps/AgencyCartSmall2';
const Styles = styled.div`
  margin: 2rem var(--universal-pad) 0;
  isolation: isolate;
  .small-type {
    position: relative;
    margin-bottom: 3rem;
    .top {
        display: flex;
        margin: 0 0 1rem;
        justify-content: space-between;
        text-decoration: none;
        color: inherit;
        .title {
            font-size: 1.25rem;
            font-weight: 600;
        }
        .action {
            text-decoration: none;
            font-weight: 700;
            color: #0094FF;
        }
    }
    .container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;
    }
    @media screen and (max-width: 850px) {
        .top {
            margin: 0 0 1rem;
        }
        .container {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
        }
    }
  }
  @media screen and (max-width: 850px) {
    margin: 2rem var(--universal-pad) 0;
  }
`
export default function AgenciesCarousel4 (props){
  const {data: dataRaw, list= [], lan} = props;
  const data = JSON.parse(dataRaw);
  const makeCarts = () => {
    let newlist = [...list].splice(0, 6);
    if(data.model === "1"){
      return newlist.map((v, i) => {
        return (
          <AgencyCart data={data} v={v} key={i} i={i} lan={lan}/>
        )
      })
    }
    if(data.model === "3"){
      return newlist.map((v, i) => {
        return (
          <AgencyCartSmall2 data={data} v={v} key={i} i={i} lan={lan}/>
        )
      })
    }
    return newlist.map((v, i) => {
      return (
        <AgencyCartSmall data={data} v={v} key={i} i={i} lan={lan}/>
      )
    })
  }
  if(data.model === "1" || data.model === "3"){
    return (
      <Styles>
        <div className='small-type'>
          {
              (data.morelink) ? (
                  <Link to={"/" + lan.filename + data.morelink} className='top'>
                      <h2 className='title'>
                          {data.title}
                      </h2>
                      <div className='action'>
                          {Dictionery.more[lan.filename]}
                      </div>
                  </Link>
              ) : (
                  <div className='top'>
                      <h2 className='title'>
                          {data.title}
                      </h2>
                  </div>
              )
          }
          <div className='container'>
              {makeCarts()}
          </div>
        </div>
      </Styles>
    )
  }
  
  return (
    <Styles>
      <CarouselMain title={data.title} moreLink={data.morelink} lan={lan}>
        {makeCarts()}
      </CarouselMain>
    </Styles>
  )
}

